import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-error"]
const _hoisted_2 = { class: "flex between-xs" }

import { ref, Ref, onMounted, nextTick, watch, PropType } from 'vue';
  import SingleDigitInputComponent from './SingleDigitInputComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PincodeInputComponent',
  props: {
    value: {
      type: String,
      default: '',
    },
    numInputs: {
      type: Number,
      default: 4,
    },
    inputType: {
      type: String as PropType<'number' | 'tel' | 'password'>,
      default: 'tel',
    },
    shouldAutoFocus: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
  },
  emits: ['focus', 'unfocus', 'update:value', 'on-complete'],
  setup(__props, { expose, emit }) {

const props = __props

  const BACKSPACE = 8;
  const LEFT_ARROW = 37;
  const RIGHT_ARROW = 39;
  const DELETE = 46;

  

  const inputRef = ref<HTMLDivElement>(null);

  

  const activeInput: Ref<number> = ref(0);
  const otp: Ref<any[]> = ref([]);
  const oldOtp: Ref<any[]> = ref([]);

  function handleOnFocus(index) {
    activeInput.value = index;
    emit('focus');
  }
  function handleOnBlur() {
    activeInput.value = -1;
    emit('unfocus');
  }

  // Focus on input by index
  function focusInput(input) {
    activeInput.value = Math.max(Math.min(props.numInputs - 1, input), 0);
  }

  // Focus on next input
  function focusNextInput() {
    focusInput(activeInput.value + 1);
  }

  // Focus on previous input
  function focusPrevInput() {
    focusInput(activeInput.value - 1);
  }

  // Helper to return OTP from input
  function checkFilledAllInputs() {
    if (otp.value.join('').length === props.numInputs) {
      emit('update:value', otp.value.join(''));
      emit('on-complete', otp.value.join(''));
    }
    return 'Wait until the user enters the required number of characters';
  }

  // Change OTP value at focused input
  function changeCodeAtFocus(value) {
    oldOtp.value = Object.assign([], otp.value);
    otp.value[activeInput.value] = value;
    if (oldOtp.value.join('') !== otp.value.join('')) {
      emit('update:value', otp.value.join(''));
      checkFilledAllInputs();
    }
  }

  // Handle pasted OTP
  function handleOnPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData
      .getData('text/plain')
      .slice(0, props.numInputs - activeInput.value)
      .split('');
    if (props.inputType === 'number' && !pastedData.join('').match(/^\d+$/)) {
      return 'Invalid pasted data';
    }
    // Paste data from focused input onwards
    const currentCharsInOtp = otp.value.slice(0, activeInput.value);
    const combinedWithPastedData = currentCharsInOtp.concat(pastedData);
    otp.value = combinedWithPastedData.slice(0, props.numInputs);
    focusInput(combinedWithPastedData.slice(0, props.numInputs).length);
    return checkFilledAllInputs();
  }

  function handleOnChange(value) {
    changeCodeAtFocus(value);
    focusNextInput();
  }

  function clearInput() {
    if (otp.value.length > 0) {
      emit('update:value', '');
    }
    otp.value = [];
    activeInput.value = 0;
  }

  // Handle cases of backspace, delete, left arrow, right arrow
  function handleOnKeyDown(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    switch (charCode) {
      case BACKSPACE:
        event.preventDefault();
        changeCodeAtFocus('');
        focusPrevInput();
        break;
      case DELETE:
        event.preventDefault();
        changeCodeAtFocus('');
        break;
      case LEFT_ARROW:
        event.preventDefault();
        focusPrevInput();
        break;
      case RIGHT_ARROW:
        event.preventDefault();
        focusNextInput();
        break;
      default:
        break;
    }
  }

  function syncOtp() {
    if (props.value?.length > 0 && props.value !== otp.value.join('')) {
      const splitted = props.value.split('').slice(0, props.numInputs);
      otp.value = splitted;
      nextTick(() => {
        focusInput(splitted.length);
      });
    }
  }

  onMounted(() => {
    syncOtp();
  });

  watch(() => props.value, syncOtp);

  expose({
    inputRef,
    clearInput,
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pincode-input", { 'has-error': __props.errorText }]),
    ref_key: "inputRef",
    ref: inputRef,
    "data-error": __props.errorText ?? ''
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.numInputs, (i) => {
        return (_openBlock(), _createBlock(SingleDigitInputComponent, {
          key: i,
          focus: activeInput.value === i - 1,
          value: otp.value[i - 1],
          "input-type": __props.inputType,
          "is-last-child": i === __props.numInputs,
          "should-auto-focus": __props.shouldAutoFocus,
          onOnChange: handleOnChange,
          onOnKeydown: handleOnKeyDown,
          onOnPaste: handleOnPaste,
          onOnFocus: ($event: any) => (handleOnFocus(i - 1)),
          onOnBlur: handleOnBlur
        }, null, 8, ["focus", "value", "input-type", "is-last-child", "should-auto-focus", "onOnFocus"]))
      }), 128))
    ])
  ], 10, _hoisted_1))
}
}

})